<template>
  <b-modal ref="modal-confirm" title="Xác nhận bàn giao" @hide="images = []">
    <div v-if="selectedItem !== null">
      <b-table class="mt-2" striped hover :items="selectedItem?.devices" :fields="tableFields">
        <template #cell(price)="data">
          <div>
            {{ data.item.price | transformMoney }}
          </div>
        </template>
      </b-table>

      <div v-if="selectedItem?.images?.length > 0">
        <div class="img-list">
          <ul v-viewer class="m-0">
            <li class="p-1 item-img" v-for="(item, index) in selectedItem?.images" :key="index">
              <a href="javascript:void(0)">
                <img :src="item" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="selectedItem?.files?.length > 0">
        <ul v-viewer class="m-0">
          <li class="p-1 item-img" v-for="(item, index) in selectedItem?.files" :key="index">
            <a :href="item" target="_blank">
              <b-icon icon="file-pdf"></b-icon> {{ item.split('/').pop() }}
            </a>
          </li>
        </ul>
      </div>

      <div class="mt-2 font-size-14" v-if="selectedItem.reasons && selectedItem.reasons.length">
        <span class="font-bold font-size-14">Lý do từ chối: </span>
        <span> {{ selectedItem?.reasons[selectedItem?.reasons?.length - 1]?.reason }}</span>
      </div>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" @click="reject">Từ chối</b-button>
        <b-button class="ml-2" variant="success" @click="handleApprove">Duyệt</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'ConfirmModal',
    props: {
      selectedItem: {
        type: Object,
        default: () => {},
      },
      disableUpload: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        tableFields: [
          { key: 'name', label: 'Tên thiết bị' },
          { key: 'serialNumber', label: 'Serial' },
          { key: 'price', label: 'Giá' },
        ],
        images: [],
      }
    },
    methods: {
      show() {
        this.$refs['modal-confirm'].show()
      },
      hide() {
        this.$refs['modal-confirm'].hide()
      },
      handleApprove() {
        this.$emit('approve')
      },
      reject() {
        this.$emit('reject')
      },
    },
  }
</script>

<style scoped lang="scss">
  .img-list {
    position: relative;
    max-height: 50vh;
    overflow-y: scroll;
  }
</style>
